import { init, register, locale, getLocaleFromNavigator, waitLocale } from 'svelte-i18n';

console.log('Starting i18n configuration');

// Register your translations from files
register('en', () => {
  console.log('Loading English translations');
  return import('../locales/en.json');
});

register('nl', () => {
  console.log('Loading Dutch translations');
  return import('../locales/nl.json');
});

// Export the initialization function
export async function initI18n() {
  console.log('Initializing i18n');
  
  init({
    fallbackLocale: 'en',
    initialLocale: localStorage.getItem('preferred-language') || getLocaleFromNavigator(),
  });

  // Wait for the initial locale to load
  await waitLocale();
  
  // Use store subscription to get current locale
  let currentLocale: string;
  locale.subscribe(value => {
    currentLocale = value;
  })();
  
  console.log('i18n initialized with locale:', currentLocale);
}

// Optional: save language preference
locale.subscribe((value) => {
  if (value) {
    console.log('Language changed to:', value);
    localStorage.setItem('preferred-language', value);
  }
}); 